<script setup lang="ts">
import PlanificLogo from "@assets/logo/planific-bright.svg"
import { useAuthStore } from "@stores/models/auth.store"

const authStore = useAuthStore()

function logout() {
  authStore.logout()
}
</script>

<template>
  <!-- Sizes step down on narrow phones so the button never slides over the
       logo, which it did on an iPhone SE (PL-70) -->
  <div class="bg-pblue flex w-full items-center justify-between gap-2 p-2 px-4">
    <div class="flex min-w-0 items-center">
      <img :src="PlanificLogo" alt="Planific" class="w-11 shrink-0 sm:w-auto">
      <div class="ms-2 text-white sm:ms-3">
        <div class="mt-2 text-2xl/5 font-medium sm:text-3xl/5">
          Planific.<span class="text-lg/5 sm:text-xl/5">ro</span>
        </div>
        <div class="text-[11px]/4 sm:text-xs/4">orice, la modul simplu</div>
      </div>
    </div>
    <div v-if="authStore.isAuthenticated" class="flex items-center">
      <button
        type="button"
        class="text-pblue shrink-0 rounded-lg bg-white px-3 py-2 text-xs font-medium whitespace-nowrap hover:bg-gray-100 focus:ring-4 focus:ring-gray-300 focus:outline-none sm:px-4 sm:text-sm"
        @click="logout"
      >
        <span class="inline-flex items-center gap-2">
          <i class="bi bi-x-lg" aria-hidden="true"></i>
          Deconectare
        </span>
      </button>
    </div>
  </div>
</template>
